export default class extends Controller {

  connect() {
    App.Helpers.listenToCustomEvent(document, "digest-day:empty", this.setEmptyState.bind(this))
    App.Helpers.listenToCustomEvent(document, "digest-day:populated", this.setPopulatedState.bind(this))
  }

  setEmptyState(event) {
    if (this.isRelevantEvent(event)) {
      this.element.classList.add("is-empty-day")
    }
  }

  setPopulatedState(event) {
    if (this.isRelevantEvent(event)) {
      this.element.classList.remove("is-empty-day")
    }
  }

  isRelevantEvent({ detail }) {
    return detail.date === this.date
  }

  get date() {
    return this.data.get("date")
  }
}



// WEBPACK FOOTER //
// ./app/components/my_via/assets/javascript/my-via-digest-day-controller.js